import React, { useContext } from 'react';
import { OrganizationContext } from '../../../containers/Context/OrganizationContext';
import HsSelect from '../../Form/HsSelect';

function LanguageSelect(props) {
  const {
    organization: { languages },
  } = useContext(OrganizationContext);

  return (
    <HsSelect
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.code}
      placeholder="Start Typing for suggestions"
      options={languages}
      {...props}
    />
  );
}

export default LanguageSelect;
